// @ts-nocheck
import { Navigate, Outlet, useLocation } from 'react-router-dom'

import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'

import { useAuth } from '@/contexts/AuthContext'

const ProtectedRoute = () => {
  const { isAuthenticated, loading } = useAuth()
  const location = useLocation()

  if (loading) {
    return (
      <Box display='flex' justifyContent='center' alignItems='center' minHeight='100vh'>
        <CircularProgress />
      </Box>
    )
  }

  if (!isAuthenticated) {
    const redirectTo = encodeURIComponent(location.pathname)

    return <Navigate to={`/en/login?redirectTo=${redirectTo}`} replace />
  }

  return <Outlet />
}

export default ProtectedRoute
